import React, { createContext, useReducer } from "react";
import {
  DevContextActions,
  DEV_DEFAULT_VALUE,
  DevContextReducer,
} from "../reducers/dev-context-reducer";

export const DevContext = createContext();

const DevContextProvider = (props) => {
  const [devState, dispatchDev] = useReducer(
    DevContextReducer,
    DEV_DEFAULT_VALUE
  );

  const setDevModeFalse = () => {
    dispatchDev({ type: DevContextActions.DEV_MODE_FALSE });
  };

  const setDevModeTrue = () => {
    dispatchDev({ type: DevContextActions.DEV_MODE_TRUE });
  };

  const setMockApiTrue = () => {
    dispatchDev({ type: DevContextActions.MOCK_API_TRUE });
  };

  const setMockApiFalse = () => {
    dispatchDev({ type: DevContextActions.MOCK_API_FALSE });
  };

  const updateScannedVin = (value) => {
    dispatchDev({ type: DevContextActions.UPDATE_SCANNED_VIN, value: value });
  };

  const updateDevLocale = (value) => {
    dispatchDev({ type: DevContextActions.UPDATE_DEV_LOCALE, value: value });
  };

  const updateInspectionType = (value) => {
    dispatchDev({
      type: DevContextActions.UPDATE_INSPECTION_TYPE,
      value: value,
    });
  };

  const updateVehicleInspectionDetails = (value) => {
    dispatchDev({
      type: DevContextActions.UPDATE_VEHICLE_INSPECTION_DETAILS,
      value: value,
    });
  };

  return (
    <DevContext.Provider
      value={{
        devState,
        devActions: {
          setDevModeFalse,
          setDevModeTrue,
          setMockApiTrue,
          setMockApiFalse,
          updateScannedVin,
          updateDevLocale,
          updateInspectionType,
          updateVehicleInspectionDetails,
        },
      }}
    >
      {props.children}
    </DevContext.Provider>
  );
};

export default DevContextProvider;
